import { guid, setCustomDataValuesToEmptyString } from "../utils";
import metadata from "./metadata";
import services from "./services";

const sendEvent = async (eventType, customFields = {}, version = "V1") => {
  console.log(`%c [Tracr] - ${eventType}`, "color: #bada55", customFields);

  const tracr = JSON.parse(localStorage.getItem("tracr"));

  if (!tracr) {
    console.log(
      `%c [Tracr] - Error: tracr is not setup`,
      "color:rgb(231, 31, 58)",
      customFields
    );
    return;
  }

  const { clientId, isNewAnonymousId } = tracr;

  const eventId = guid();
  const anonymousId = metadata.getAnonymousId();
  const sessionId = metadata.getSessionId();

  const formatedCustomData = setCustomDataValuesToEmptyString(customFields);

  const payload = {
    data: {
      pageName: formatedCustomData.pageName,
      ...customFields,
    },
    metadata: {
      clientId,
      eventId,
      eventType,
      version,
      timestamp: new Date().toISOString(),
      identifiers: {
        documentNumber: formatedCustomData.documentNumber,
        email: formatedCustomData.email,
        phoneNumber: formatedCustomData.phoneNumber,
        userId: formatedCustomData.userId,
        anonymousId,
        sessionId,
        userAgent: navigator.userAgent,
        timezoneOffset: new Date().getTimezoneOffset(),
        newAnonymousId: isNewAnonymousId,
      },
      webContext: {
        referrer: document.referrer,
        title: document.title,
        url: location.href,
        revisionId: formatedCustomData.revisionId,
        pageType: document.contentType,
        postId: formatedCustomData.postId,
      },
    },
  };

  await services.sendEvent(payload);
};

const Events = {
  sendEvent,
  pageview(pageName) {
    sendEvent("PageViewed", { pageName });
  },
  scroll(scrollDistance) {
    sendEvent("PageScrolled", { scrollDistance });
  },
};

export default Events;
